export enum EventType {
    ON_SITE = 'onSite',
    TELEMEDICINE = 'telemedicine'
}